// The editor origins allowed to frame the renderer (lureo-docs#120); Unity keeps the same list in the template and
// in RendererBridge.jslib, and the backend's CORS list mirrors it.
export const ALLOWED_PARENT_ORIGINS: readonly string[] = Object.freeze([
  "https://lureo.app",
  "https://create.lureo.com",
  "https://create.staging.lureo.com",
  "http://localhost:5173",
  "http://localhost:5174",
  "http://localhost:3000",
  "http://localhost:8080",
]);

// The messages the WebGL template answers itself; they never reach the renderer's bridge.
export const TEMPLATE_MESSAGE_TYPES: readonly string[] = Object.freeze(["setJwt", "checkCanvasReady", "requestScreenshot"]);
